export default [
  {
    path: '/learning-center-quiz',
    name: 'learning-center-quiz',
    component: () => import('./pages/QuizList.vue'),
    meta: {
      resource: 'drivers-quiz',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Learning Center Quiz Management',
      breadcrumb: [
        {
          text: 'Learning Center Quiz Management',
          active: true,
        },
      ],
    },
  },
  {
    path: '/learning-center-quiz/new',
    name: 'learning-center-quiz-new',
    component: () => import('./pages/AddQuiz.vue'),
    meta: {
      resource: 'drivers-quiz',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Add New Question',
      breadcrumb: [
        {
          text: 'Learning Center Quiz Management',
          to: '/learning-center-quiz',
        },
        {
          text: 'Add New Question',
          active: true,
        },
      ],
    },
  },
  {
    path: '/learning-center-quiz/edit/:id',
    name: 'learning-center-quiz-edit',
    component: () => import('./pages/EditQuiz.vue'),
    meta: {
      resource: 'drivers-quiz',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Question',
      breadcrumb: [
        {
          text: 'Learning Center Quiz Management',
          to: '/learning-center-quiz',
        },
        {
          text: 'Edit Question',
          active: true,
        },
      ],
    },
  },
]
